import React from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import LiveTooltip from 'live/components/ui/tooltip'

// flags a channel whose selection is driven by the query's own `selected` @meta default, rather
// than a user's manual pick - shown inline at the start of the second (mnemonic/category) line,
// wherever the channel appears (Selected, or the Removed dynamic channels panel once removed)
export const DynamicChannelBadge = (): JSX.Element => (
    <LiveTooltip position="top" content={i18n('Dynamic channel selected through query')}>
        <Icon className="fa fa-code" />
    </LiveTooltip>
)

// deliberately smaller than RowMeta's own 11px, and the same muted gray, so it reads as a compact
// tag at the start of that line rather than competing with the text for attention
const Icon = styled.i`
    flex-shrink: 0;
    font-size: 8px;
    color: var(--gray-600);
`
